import api from '@/utils/api'
import categories from '@/store/wishes/categories'

export default {
  modules: {
    categories,
  },
  state: () => ({
    wishes: null,
    reasons: [],
    wishStates: [],
  }),
  mutations: {
    setWishes(state, payload) {
      state.wishes = payload
    },
    setReasons(state, payload) {
      state.reasons = payload
    },
    setWishStates(state, payload) {
      state.wishStates = payload
    },
  },
  getters: {
    getWishStateByKey: state => {
      return key => {
        return state.wishStates.find(x => x.value === key).title
      }
    },
    wishStatesTransformed: state => {
      return state.wishStates.map(item => {
        return {
          key: item,
          label: item,
        }
      })
    },
  },
  actions: {
    async fetchWishes({commit}, params) {
      const copy = {...params}
      if (!copy.search) delete copy.search
      if (!copy.state) delete copy.state
      const res = await api.http.get('admin/wishes', {params: copy})
      commit('setWishes', res?.data)
    },

    async fetchWish(_, id) {
      const res = await api.http.get(`admin/wishes/${id}`)
      return res?.data?.data
    },

    async approveWish(_, id) {
      await api.http.post(`admin/wishes/${id}/approve`)
    },

    async discardWish(_, {id, form}) {
      await api.http.post(`admin/wishes/${id}/discard`, form)
    },

    async fetchReasons({commit}, params) {
      const res = await api.http.get('admin/wishes/reasons', {params})
      commit('setReasons', res?.data?.data)
    },

    async fetchWishStates({commit}) {
      const res = await api.http.get('admin/wishes/states')
      commit('setWishStates', res?.data)
    },

    async fetchWishesByUserSlug(_, userSlug) {
      const res = await api.http.get(`/admin/wishes/${userSlug}/user-wishes-by-slug`)
      return res?.data.data
    },

    async takeMutex(_, id) {
      await api.http.post(`admin/wishes/${id}/mutex`)
    },

    async leaveMutex(_, id) {
      await api.http.delete(`admin/wishes/${id}/mutex`)
    },

    async updateWish(_, {id, form}) {
      const formClone = {...form}
      formClone.images = formClone.images.map(x => x.id)
      if(formClone.category_id !== formClone.category?.[formClone.category.length -1] && Array.isArray(formClone.category)) {
        formClone.category_id = formClone.category[formClone.category.length -1]
      }
      await api.http.post(`admin/wishes/${id}`, formClone)

    },

    async deleteWish(_, id) {
      return await api.http.delete(`admin/wishes/${id}`)
    },
  },
  namespaced: true,
}
